export default __webpack_public_path__ + "2ba3b6187349a03cf2eedfc04fb76376.svg";